// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adm-grid {\n  --gap: 0;\n  --gap-horizontal: var(--gap);\n  --gap-vertical: var(--gap);\n  display: grid;\n  grid-gap: 10px;\n  -webkit-column-gap: var(--gap-horizontal);\n  column-gap: var(--gap-horizontal);\n  row-gap: var(--gap-vertical);\n  grid-template-columns: repeat(var(--columns), minmax(0, 1fr));\n  align-items: stretch;\n}\n.adm-grid-item {\n  grid-column-end: span var(--item-span);\n}\n", ""]);
// Exports
module.exports = exports;
